import { getEpisodeOfCareProgressNotesConnectionId } from "@/modules/patients/detail/episode-of-care/lib/get-episode-of-care-connection"
import type { EpisodeOfCareNode } from "@/modules/patients/detail/episode-of-care/types/episode-of-care-fragment-type"
import { getIsProgressNoteEditable } from "@/modules/patients/detail/progress-note/lib/get-is-progress-note-editable"
import { Language } from "@/modules/patients/services/__generated__/PatientAppointmentFragment.graphql"
import type { Ch_createProgressNoteInput } from "@/modules/patients/services/ch/__generated__/chCreateProgressNoteMutation.graphql"
import { createProgressNote } from "@/modules/patients/services/createProgressNote"
import type { De_createProgressNoteInput } from "@/modules/patients/services/de/__generated__/deCreateProgressNoteMutation.graphql"
import type { Country, ProgressNoteKind } from "@/types/__generated__/union-types"

type ValidateProgressNoteCreatableProps = {
  progressNoteKind: ProgressNoteKind | null
  dataPatientEpisodesOfCareData: EpisodeOfCareNode[] | undefined
  userName: string
  appointmentId: string | null
  isInContextOfAppointment: boolean
}

export const validateProgressNoteCreatable = (options: ValidateProgressNoteCreatableProps) => {
  const { appointmentId, dataPatientEpisodesOfCareData, isInContextOfAppointment, progressNoteKind, userName } = options

  switch (progressNoteKind) {
    case "ADMINISTRATIVE":
      return true
    case "MEDICAL":
      return (
        dataPatientEpisodesOfCareData
          ?.find((e) => e.isVirtual)
          ?.progressNotes?.edges?.every(({ node }) => {
            return !getIsProgressNoteEditable(node, userName, appointmentId, isInContextOfAppointment)
          }) ?? true
      )
    case null:
      return false
  }
}

type CreateProgressNoteProps = {
  progressNoteKind: ProgressNoteKind | null
  dataPatientEpisodesOfCareData: EpisodeOfCareNode[] | undefined
  appointmentId: string
  patientId: string
  countryCode: Country
  language: Language
}

export const createProgressNoteHandler = (props: CreateProgressNoteProps) => {
  const { appointmentId, countryCode, dataPatientEpisodesOfCareData, patientId, progressNoteKind, language } = props
  if (!progressNoteKind) return

  const input: De_createProgressNoteInput & Ch_createProgressNoteInput = {
    appointmentId,
    patientId,
    episodeOfCareId: null,
    kind: progressNoteKind,
    language,
  }

  const connectionId = getEpisodeOfCareProgressNotesConnectionId(
    dataPatientEpisodesOfCareData!.find((e) => e.isVirtual)!.id,
  )

  createProgressNote(countryCode, input, [connectionId])
}
